import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function medicineDoseValidator(control: FormGroup): ValidationErrors | null {
    const needMedicalTreatment = control.value.needMedicalTreatment;
    const medicineDose = control.value.medicinesQuantity;
    return needMedicalTreatment && !medicineDose ? { "medicineDoseMissing": true } : null;
}